module.exports = __webpack_public_path__ + "img/012岳晋琛.7f4c7239.png";